(() => {
  if (customElements.get('whalebud-social-gallery')) return;

class WhalebudSocialGallery extends HTMLElement {
  connectedCallback() {
    this.whalebudCleanup();

    this.whalebudViewport = this.querySelector('[data-whalebud-social-viewport]');
    this.whalebudItems = [...this.querySelectorAll('[data-whalebud-social-item]')];
    this.whalebudControls = this.querySelector('[data-whalebud-social-controls]');
    this.whalebudPrevious = this.querySelector('[data-whalebud-social-previous]');
    this.whalebudNext = this.querySelector('[data-whalebud-social-next]');
    this.whalebudStatus = this.querySelector('[data-whalebud-social-status]');
    this.whalebudAbortController = new AbortController();

    if (!this.whalebudViewport || this.whalebudItems.length < 1) return;

    const whalebudSignal = this.whalebudAbortController.signal;
    this.whalebudPrevious?.addEventListener('click', () => this.whalebudGoToPage(this.whalebudCurrentPage - 1, true), { signal: whalebudSignal });
    this.whalebudNext?.addEventListener('click', () => this.whalebudGoToPage(this.whalebudCurrentPage + 1, true), { signal: whalebudSignal });
    this.whalebudViewport.addEventListener('keydown', (whalebudEvent) => this.whalebudHandleKeydown(whalebudEvent), { signal: whalebudSignal });
    this.whalebudViewport.addEventListener('scroll', () => this.whalebudHandleScroll(), { passive: true, signal: whalebudSignal });
    document.addEventListener('shopify:block:select', (whalebudEvent) => this.whalebudHandleBlockSelect(whalebudEvent), { signal: whalebudSignal });

    this.whalebudResizeObserver = new ResizeObserver(() => this.whalebudUpdate(false));
    this.whalebudResizeObserver.observe(this.whalebudViewport);
    this.whalebudCurrentPage = 0;
    this.whalebudUpdate(false);
  }

  disconnectedCallback() {
    this.whalebudCleanup();
  }

  whalebudCleanup() {
    this.whalebudAbortController?.abort();
    this.whalebudResizeObserver?.disconnect();
    window.cancelAnimationFrame(this.whalebudScrollFrame);
  }

  whalebudHandleKeydown(whalebudEvent) {
    const whalebudKeys = ['ArrowLeft', 'ArrowRight', 'Home', 'End', 'PageUp', 'PageDown'];
    if (!whalebudKeys.includes(whalebudEvent.key)) return;
    whalebudEvent.preventDefault();

    if (whalebudEvent.key === 'ArrowLeft' || whalebudEvent.key === 'PageUp') this.whalebudGoToPage(this.whalebudCurrentPage - 1, true);
    if (whalebudEvent.key === 'ArrowRight' || whalebudEvent.key === 'PageDown') this.whalebudGoToPage(this.whalebudCurrentPage + 1, true);
    if (whalebudEvent.key === 'Home') this.whalebudGoToPage(0, true);
    if (whalebudEvent.key === 'End') this.whalebudGoToPage(this.whalebudPageCount() - 1, true);
  }

  whalebudHandleBlockSelect(whalebudEvent) {
    const whalebudItem = this.querySelector(`[data-whalebud-block-id="${CSS.escape(whalebudEvent.detail.blockId)}"]`);
    if (!whalebudItem) return;
    const whalebudPage = Math.floor(whalebudItem.offsetLeft / Math.max(this.whalebudViewport.clientWidth, 1));
    this.whalebudGoToPage(whalebudPage, false);
  }

  whalebudHandleScroll() {
    window.cancelAnimationFrame(this.whalebudScrollFrame);
    this.whalebudScrollFrame = window.requestAnimationFrame(() => this.whalebudUpdate(false));
  }

  whalebudPageCount() {
    const whalebudWidth = Math.max(this.whalebudViewport.clientWidth, 1);
    return Math.max(1, Math.ceil((this.whalebudViewport.scrollWidth - 1) / whalebudWidth));
  }

  whalebudGoToPage(whalebudRequestedPage, whalebudAnnounce) {
    const whalebudPageCount = this.whalebudPageCount();
    const whalebudPage = Math.max(0, Math.min(whalebudRequestedPage, whalebudPageCount - 1));
    const whalebudReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    this.whalebudViewport.scrollTo({
      left: whalebudPage * this.whalebudViewport.clientWidth,
      behavior: whalebudReducedMotion ? 'auto' : 'smooth',
    });
    this.whalebudCurrentPage = whalebudPage;
    this.whalebudUpdate(whalebudAnnounce);
  }

  whalebudUpdate(whalebudAnnounce) {
    const whalebudWidth = Math.max(this.whalebudViewport.clientWidth, 1);
    const whalebudPageCount = this.whalebudPageCount();
    this.whalebudCurrentPage = Math.max(0, Math.min(Math.round(this.whalebudViewport.scrollLeft / whalebudWidth), whalebudPageCount - 1));

    if (this.whalebudControls) this.whalebudControls.hidden = whalebudPageCount <= 1;
    if (this.whalebudPrevious) this.whalebudPrevious.disabled = this.whalebudCurrentPage === 0;
    if (this.whalebudNext) this.whalebudNext.disabled = this.whalebudCurrentPage === whalebudPageCount - 1;

    if (whalebudAnnounce && this.whalebudStatus) {
      this.whalebudStatus.textContent = `Gallery page ${this.whalebudCurrentPage + 1} of ${whalebudPageCount}`;
    }
  }
}

customElements.define('whalebud-social-gallery', WhalebudSocialGallery);
})();
